if (typeof AnnouncementBar !== 'function') {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = Array.from(this.querySelectorAll('.announcement'));
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.autoPlayInterval = null; // Para o autoplay
      this.autoPlayDelay = 4500; // Intervalo entre slides (em milissegundos)
      this.index = 0;

      // Clonar os elementos no início e no fim para criar o loop
      this.cloneSlides();

      // Inicializar o slider
      this.setInitialPosition();

      // Adicionar eventos dos botões
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
          this.resetAutoPlay();
        });
      }

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
          this.resetAutoPlay();
        });
      }

      // Configurar autoplay
      this.startAutoPlay();

      // Pausar autoplay ao clicar botão
      /*this.slider.addEventListener('mouseenter', () => this.stopAutoPlay());
      this.slider.addEventListener('mouseleave', () => this.startAutoPlay());*/
      this.slider.parentElement.querySelector('.announcement-bar_slide_loop .announcement-bar__content-nav--loop.start-loop').addEventListener('click', () => this.startAutoPlay());
      this.slider.parentElement.querySelector('.announcement-bar_slide_loop .announcement-bar__content-nav--loop.stop-loop').addEventListener('click', () => this.stopAutoPlay());
    }

    cloneSlides() {
      const firstSlide = this.content[0];
      const lastSlide = this.content[this.content.length - 1];

      // Clonar o primeiro e o último slide
      const firstClone = firstSlide.cloneNode(true);
      const lastClone = lastSlide.cloneNode(true);

      // Adicionar os clones
      this.slider.appendChild(firstClone);
      this.slider.insertBefore(lastClone, this.content[0]);

      // Atualizar a lista de slides
      this.content = Array.from(this.slider.querySelectorAll('.announcement'));
    }

    setInitialPosition() {
      // Centralizar no slide original
      this.slider.scrollTo({
        top: 0,
        left: this.content[1].offsetLeft,
        behavior: 'instant',
      });
      this.index = 1; // Definir o índice inicial
    }

    changeSlide(direction) {
      if (direction === 'next') {
        this.index++;
      } else if (direction === 'prev') {
        this.index--;
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth',
      });

      // Verificar se atingiu o clone no início ou no fim
      setTimeout(() => {
        if (this.index === 0) {
          this.index = this.content.length - 2; // Salta para o último slide real
          this.slider.scrollTo({
            top: 0,
            left: this.content[this.index].offsetLeft,
            behavior: 'instant',
          });
        } else if (this.index === this.content.length - 1) {
          this.index = 1; // Salta para o primeiro slide real
          this.slider.scrollTo({
            top: 0,
            left: this.content[this.index].offsetLeft,
            behavior: 'instant',
          });
        }
      }, 700); // Aguardar a animação terminar
    }

    startAutoPlay() {
      this.slider.parentElement.querySelector('.announcement-bar_slide_loop .announcement-bar__content-nav--loop.start-loop').style.display = "none";
      this.slider.parentElement.querySelector('.announcement-bar_slide_loop .announcement-bar__content-nav--loop.stop-loop').style.display = "flex";
      this.autoPlayInterval = setInterval(() => {
        this.changeSlide('next');
      }, this.autoPlayDelay);
    }

    stopAutoPlay() {
      this.slider.parentElement.querySelector('.announcement-bar_slide_loop .announcement-bar__content-nav--loop.start-loop').style.display = "flex";
      this.slider.parentElement.querySelector('.announcement-bar_slide_loop .announcement-bar__content-nav--loop.stop-loop').style.display = "none";
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }

    resetAutoPlay() {
      this.stopAutoPlay();
      this.startAutoPlay();
    }
  }

  if (typeof customElements.get('announcement-bar') == 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }
}
